import React, {useState, useEffect} from "react";
import Loader from "react-loader-spinner";
import {useSelector, useDispatch} from 'react-redux';
import * as userAuthActions from '../../Redux/Actions/user';

const Login = ({history}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const userData = useSelector(({User}) => User.data);
    const dispatch = useDispatch();

    useEffect(() => {
        userData && userData.UserId && history.push('/dashboard');
    }, [userData, history]);

    const handleUserLogin = () => {
        let payload = {
            "userName": email,
            "password": password,
            "role": "SUPERADMIN"
        };
        setButtonLoading(true);
        if((email !== '') && (password !== '')){
            userAuthActions.userLogin(payload).then(res => {
                if(res && res.status === 200){
                    let jwtResponse = parseJwt(res.data.data.token);
                    localStorage.setItem('jwt', res.data.data.token);
                    dispatch(userAuthActions.userData(jwtResponse));
                    history.push('/dashboard');
                    setButtonLoading(false);
                }
            }).catch(err => {
                setButtonLoading(false);
                setErrorMsg(err.response.data.message);
            });
        }else{
            setErrorMsg('Enter the correct user name and password');
        }
    };

    const parseJwt = (token) => {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    };

    return (
        <div className="login-form login-signin">
            <div className="text-center mb-10 mb-lg-20">
                <h3 className="font-size-h1">Login Account</h3>
                <p className="text-muted font-weight-bold">Enter your username and password</p>
            </div>
        
            <form className="form fv-plugins-bootstrap fv-plugins-framework">
                <div className="form-group fv-plugins-icon-container">
                    <input placeholder="Email" type="email" className={"form-control form-control-solid h-auto py-5 px-6"}
                        name="email" value={email} onChange={e => {setEmail(e.target.value); setErrorMsg('')}}
                    />
                </div>
                <div className="form-group fv-plugins-icon-container">
                    <input placeholder="Password" type="password" className={`form-control form-control-solid h-auto py-5 px-6`}
                        value={password} onChange={e => {setPassword(e.target.value); setErrorMsg('')}}
                    />
                    {errorMsg && <p className="text-danger m-2 text-center font-weight-bold">{errorMsg}</p>}
                    <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                        <p onClick={() => history.push("/forgot-password")} className="cursor-pointer text-dark-50 text-hover-primary my-3 mr-2">
                            Forgot Password ?
                        </p>
                        <button onClick={handleUserLogin} disabled={buttonLoading} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold px-9 py-4 my-3">
                            Sign In {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Login;